.productPrice {
  text-align: left;

  &.productPriceLarge,
  &.productPriceMedium {
    .productPriceItem {
      display: grid;
      grid-template-columns: 50% 1fr;
      column-gap: 0;
      margin-bottom: 0;
      font-size: var(--product-block-font-size);
    }
  }

  &.productPriceMedium .productPriceItem {
    min-height: 2.4rem;
  }

  &.productPriceLarge {
    container-type: inline-size;

    .productPriceItem {
      min-height: calc(50cqw / 7.5);
    }
  }

  &.productPriceMedium .productPriceItemLabel,
  &.productPriceLarge .productPriceItemLabel {
    gap: 0.6rem;
  }

  &.productPriceLarge .productPriceItemIcon {
    font-size: 1.8rem;
  }

  &.productPriceMedium .productPriceValue {
    justify-content: flex-end;
  }
}

.productPriceItem {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--gap-small);
  margin-bottom: var(--gap-small);
  font-size: 1.4rem;
}

.productPriceItemLabel {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  color: var(--color-neutral-lightest);
}

.productPriceItemIcon {
  font-size: 1.3rem;
}

.productPriceValue {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--gap-regular);
}

.productPriceAbs {
  font-size: 1.6rem;
  color: var(--color-secondary);
  white-space: nowrap;

  @media (--smartphone) {
    font-size: 1.4rem;
  }
}

.productPriceCt {
  color: var(--color-secondary);
  font-size: 1.3rem;
  white-space: nowrap;

  @media (--smartphone) {
    font-size: 1rem;
  }
}
